import React from "react";
import classes from "./Footer.module.scss";
import { FormattedMessage } from "react-intl";

const Footer = () => {
  return (
    <>
      <div style={{height: "4rem"}}>&nbsp;</div>
      <div className={classes.footerMain}>
       <FormattedMessage id="UTC_TEXT" />
      </div>
    </>
  );
};

export default Footer;
